module.exports = __webpack_public_path__ + "static/img/Winonah-Heatley.b6a1a08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Winonah-Heatley.jpg
// module id = X/gg
// module chunks = 0